<ion-content class="wrapper">

  <div class="header">
    <p class="title">Order no. {{ data.orderNumber }}</p>
    <div *ngIf="data.order.order.isInDelivery" class="in-progress">
      <ion-icon [src]="getVehicleIcon((account$ | async)?.currentSelectedVehicle?.type!)"></ion-icon>
      <p>Onderweg</p>
    </div>
  </div>

  <div *ngIf="data.order.order.isInDelivery" class="view-buttons">
    <div class="view-button" [ngClass]="{'selected' : currentView == OrderPreviewView.Overview }"
      (click)="changeView(OrderPreviewView.Overview)">
      <ion-icon src="../../assets/icon/article.svg"></ion-icon>
    </div>
    <div class="view-button" [ngClass]="{'selected' : currentView == OrderPreviewView.Mail}"
      (click)="changeView(OrderPreviewView.Mail)">
      <ion-icon src="../../assets/icon/email.svg"></ion-icon>
    </div>
    <div class="view-button" [ngClass]="{
        'selected' : currentView == OrderPreviewView.ExtraInfo,
        'warning' : !!data.order.client.oneTimeExtraInfo,
        'wiggle' : !!data.order.client.oneTimeExtraInfo && !hasClickedExtraInfo
     }" (click)="changeView(OrderPreviewView.ExtraInfo)">
      <ion-icon src="../../assets/icon/fill-in.svg"></ion-icon>
      <div *ngIf="!!data.order.client.oneTimeExtraInfo" class="tab-status-badge warning"></div>
    </div>
    <div class="view-button" [ngClass]="{'selected' : currentView == OrderPreviewView.Upload }"
      (click)="changeView(OrderPreviewView.Upload)">
      <ion-icon src="../../assets/icon/export.svg"></ion-icon>
    </div>
    <div>
      <div class="view-button" [ngClass]="{'selected' : currentView == OrderPreviewView.Payment }"
        (click)="changeView(OrderPreviewView.Payment)">
        <ion-icon src="../../assets/icon/card.svg"></ion-icon>
      </div>
      <div class="tab-status-badge" [ngClass]="{'complete': data.order.order.paymentComplete}"></div>
    </div>
  </div>

  <div [ngSwitch]="currentView">
    <app-order-detail *ngSwitchCase="OrderPreviewView.Overview" [data]="data"></app-order-detail>
    <app-extra-info *ngSwitchCase="OrderPreviewView.ExtraInfo" [data]="data"></app-extra-info>
    <app-order-photos *ngSwitchCase="OrderPreviewView.Upload" [data]="data"></app-order-photos>
    <app-payment *ngSwitchCase="OrderPreviewView.Payment" [data]="data"></app-payment>
    <app-mail *ngSwitchCase="OrderPreviewView.Mail" [data]="data"></app-mail>
  </div>
</ion-content>